import * as React from 'react'

import { useLoginByEmailPage } from './hooks'
import { $qrCodeData, submitForm } from './model'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormFeedback,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import { QRCodeModal } from './widgets/QRCodeModal'
import { useStore } from 'effector-react'
import { useEffect, useState } from 'react'

export const Login = () => {
  const { form } = useLoginByEmailPage()
  const { loading, error } = form
  const [isOpenQrModal, setIsOpenQrModal] = useState(false)

  const qrCodeData = useStore($qrCodeData)

  const handleLogin = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    submitForm({
      // @ts-ignore
      username: e.target.username.value,
      // @ts-ignore
      password: e.target.password.value,
      // @ts-ignore
      authCode: e.target.authCode.value,
    })
  }

  useEffect(() => {
    if (qrCodeData) {
      setIsOpenQrModal(true)
    }
  }, [qrCodeData])

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={4}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm
                    className="row g-3 needs-validation"
                    noValidate
                    onSubmit={handleLogin}
                  >
                    <h1>Login</h1>
                    <p className="text-medium-emphasis">
                      Sign In to your account
                    </p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="Username"
                        autoComplete="username"
                        name="username"
                        required
                      />
                      <CFormFeedback invalid>Field is required</CFormFeedback>
                    </CInputGroup>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        name="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        required
                      />
                      <CFormFeedback invalid>Field is required</CFormFeedback>
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="Auth code"
                        autoComplete="authCode"
                        name="authCode"
                        required
                      />
                      <CFormFeedback invalid>Field is required</CFormFeedback>
                    </CInputGroup>
                    <CRow>
                      <CCol xs={6}>
                        <CButton
                          color="primary"
                          className="px-4"
                          type="submit"
                          disabled={loading}
                        >
                          {loading && (
                            <span className="spinner-border spinner-border-sm"></span>
                          )}
                          Login
                        </CButton>
                      </CCol>
                    </CRow>
                    <CRow className="mt-4">
                      <CCol xs={6}>
                        {error && (
                          <div className="form-group">
                            <div className="alert alert-danger" role="alert">
                              {error?.fields?.password}
                              {error?.msg}
                            </div>
                          </div>
                        )}
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
        {qrCodeData && (
          <QRCodeModal
            isVisible={isOpenQrModal}
            onClose={() => setIsOpenQrModal(false)}
            qrCodeData={qrCodeData}
          />
        )}
      </CContainer>
    </div>
  )
}
